var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-logo"},[_c('nuxt-link',{staticClass:"d-flex",attrs:{"exact":"","to":"/"}},[_c('img',{staticClass:"navbar-logo",attrs:{"alt":"","src":require("../../../assets/nuvoair-logo-white.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }